export class ContractSearchCriteria {
  NetworkName: string;
  DateRangeFrom: Date;
  DateRangeTo: Date;
  PayerGroupName: string[];
  ContractTypeIds: number[];
  ContractStatusIds: number[];
}
